import { render, staticRenderFns } from "./SceneMetaTabCopy.vue?vue&type=template&id=1a60c313"
import script from "./SceneMetaTabCopy.vue?vue&type=script&lang=js"
export * from "./SceneMetaTabCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports